<template>
  <div class="after-chat">
    <div v-if="!isSurveyOnly">
      <v-overlay v-model="message" absolute attach=".chat-text-input" scroll-strategy="none">
        <v-card class="overlay-dialog">
          <v-card-title class="dialog-title">
            <v-img
              v-if="afterChatView.chatIconLink"
              class="dialog-icon"
              cover 
              :src="afterChatView.chatIconLink"
            ></v-img>
            <v-img
              v-else-if="!afterChatView.chatIconLink"
              class="dialog-icon"
              cover 
              :src="require('@/assets/Chat.svg')"
            ></v-img>
          </v-card-title>
          <v-card-text class="dialog-text">
            {{ message }}
          </v-card-text>
          <v-card-actions class="dialog-actions" v-if="!$store.state.isCallback">
            <v-btn
              block
              class="close-dialog-button"
              @click="message = false"
            >
              {{ conversationView.closeBtnLabel ? conversationView.closeBtnLabel : 'Close'}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-overlay>
      <div class="header" v-if="!$store.state.isCallback">
        <v-card class="mx-auto header-content">
          <v-card-text>
            <v-img
              class="title-icon-img"
              cover 
              :src="afterChatView.titleIconLink"
            ></v-img>
            <span>{{ afterChatView.title }}</span>

            <!-- restart button -->
            <v-tooltip location="bottom" :text="afterChatView.restartBtnLabel">
              <template v-slot:activator="{ props }">
                <v-btn                  
                  v-bind="props"
                  id="restart-btn"
                  class="restart-button"
                  size="x-small"
                  @click="
                    $EventBus.emit('handleRestartButtonClick');                    
                    showTooltip('tooltip-restart-chat');
                  "
                  icon
                >
                  <img location="left" :src="afterChatView.restartBtnImageLink" />
                </v-btn>
              </template>
            </v-tooltip>
            <!-- end restart button -->
          </v-card-text>
        </v-card>
      </div>

      <div class="content" v-if="!$store.state.isCallback">
        <v-card class="history-messages-card">
          <v-textarea
            variant="solo"
            ref="txtarea"
            style="width: 100%; height:100%"
            rows="20"
            readonly
            no-resize
            v-model="textareaData"
            class="history-messages-text"
          >
          </v-textarea>

          <!-- copy button -->
          <v-tooltip v-if="!widgetData.config.isShowDownloadChat" location="bottom">
            <template v-slot:activator="{ props }">
              <v-btn
              v-bind="props"
                @click="
                  onCopyToClipboard();
                  showTooltip('tooltip-copy');
                "
                id="copyButton"
                icon
                dark
              >
                <v-img
                  style="max-width: 20px;"
                  :src="afterChatView.btnCopyToClipboardIconLink"
                ></v-img>
              </v-btn>
            </template>
            <span id="tooltip-copy">
              {{
                afterChatView.copyBtnTooltipLabel
                  ? afterChatView.copyBtnTooltipLabel
                  : "Copy"
              }}
            </span>
          </v-tooltip>

          <!-- download button -->
          <v-tooltip 
          :text="afterChatView.downloadBtnTooltipLabel ? afterChatView.downloadBtnTooltipLabel : 'Download'" 
          location="bottom" 
          v-if="widgetData.config.isShowDownloadChat">
            <template v-slot:activator="{ props }">
              <v-btn
              v-bind="props"
                @click="
                  downloadTranscript();
                  showTooltip('tooltip-download');
                "
                id="downloadButton"
                icon
                dark
              >
                <img
                  style="width: 30px;"
                  :src="afterChatView.btnDownloadIconLink"
                />
              </v-btn>
            </template>
          </v-tooltip>
        </v-card>
      </div>
    </div>
    <div v-if="isSurveyOnly">
      <v-card class="overlay-dialog" >
          <v-card-title class="dialog-title">
            <v-img
              v-if="afterChatView.chatIconLink"
              class="dialog-icon"
              cover 
              :src="afterChatView.chatIconLink"
            ></v-img>
            <v-img
              v-else-if="!afterChatView.chatIconLink"
              class="dialog-icon"
              cover 
              :src="require('@/assets/Chat.svg')"
            ></v-img>
          </v-card-title>
          <v-card-text class="dialog-text">
            {{ afterChatView.afterChatPredefinedMessage }}
          </v-card-text>
        </v-card>
    </div>
  </div>
</template>

<script>
import fileSaver from "file-saver/dist/FileSaver";

import { mapGetters } from "vuex";
import Utils from "../helpers/utils";
export default {
  name: "AfterChat",
  data() {
    return {
      textareaData: "",
      isSurveyOnly: this.$store.state.isSurveyOnly,
      message: "",
    };
  },
  created() {
    Utils.log.debug("AfterChatView created");
    this.buildTextDataForTextArea();
    Utils.postMessageObject("status", "callEnded");
    if (this.widgetData.config.externalController == true)
      window.parent.postMessage({CC:{"removeCC": true}}, "*");
    this.message = (!this.$store.state.isCallback || !this.afterChatView.afterChatPredefinedMessageCallback) ? 
        this.afterChatView.afterChatPredefinedMessage : this.afterChatView.afterChatPredefinedMessageCallback;
  },
  methods: {
    showTooltip(id) {
      if (
        (!Utils.mobileCheck() && !Utils.isSafari()) ||
        (Utils.mobileCheck() && this.widgetData.config.disableTooltipOnMobile)
      ) {
        return;
      }
      let el = document.querySelector("#" + id);
      if (el) {
        Utils.log.debug("showTooltip: " + id);
        document.querySelector("#" + id).parentElement.style.display = "block";
        document.querySelector("#" + id).parentElement.style.opacity = "0.9";
        setTimeout(() => {
          document.querySelector("#" + id).parentElement.style.display = "none";
        }, 1000);
      }
    },
    buildTextDataForTextArea() {
      for (let it of this.conversationData) {
        let author = it.author ? it.author : "System";
        this.textareaData = this.textareaData.concat(
          it.time + " " + author + ": " + it.text + "\n"
        );

        if(it.translatedText){
          this.textareaData = this.textareaData.concat(
          `Translation ${it.translatedData.src ? it.translatedData.src : 'unknown'} => ${it.translatedData.trg ? it.translatedData.trg : 'unknown'} : ${it.translatedText} \n`);
        }
      }
    },
    onCopyToClipboard() {
      let el = this.$refs.txtarea;
      el.focus();
      document.execCommand("selectAll");
      document.execCommand("copy");
    },
    downloadTranscript() {
      let blob = new Blob([this.textareaData], {
        type: "text/plain;charset=utf-8",
      });
      saveAs(blob, `chatTranscript(${new Date().toLocaleString()}).txt`);
    },
  },
  computed: {
    isMobile() {
      return Utils.mobileCheck();
    },
    isShowTooltipOnHover() {
      return (
        (this.isMobile && !this.widgetData.config.disableTooltipOnMobile) ||
        !this.isMobile
      );
    },
    ...mapGetters([
      "conversationData",
      "appData",
      "widgetData",
      "afterChatView",
      "translationConfig",
      "conversationView",
      // ...
    ]),
  },
};
</script>

<style scoped>
.overlay-dialog {
  width: 80%;
  margin: auto;
  background: #fff;
}

.overlay-dialog .dialog-title {
  justify-content: center;
  padding-top: 20px;
}

.overlay-dialog .dialog-icon {
  max-width: 50px;
}

.overlay-dialog .dialog-text {
  font-size: 15pt;
  color: #000;
  padding: 25px;
  text-align: center;
}

.overlay-dialog .dialog-actions {
  padding: 25px;
}

.header {
  height: 65px;
}

.header > .header-content {
  box-shadow: 0px 12px 20px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  border-radius: 0;
}

.content {
  height: calc(100% - 65px);
}

.title-icon-img {
  padding-right: 5px;
  max-width: 30px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
  opacity: 0.5;
}

.predefined-message {
  margin-top: 5px;
  margin-bottom: 5px;
  height: 80px;
  overflow-y: auto;
}

.after-chat {
  width: 100%;
  height: 100%;
  background-color: #f5f8fc;
}

#copyButton {
  bottom: 100px;
  position: absolute;
  right: 0;
  margin-top: 10px;
  margin-right: 20px;
  z-index: 1;
  width: 50px;
  height: 50px;
  background: #4fc1ec;
  border-color: #4fc1ec;
}

#downloadButton {
  bottom: 100px;
  position: absolute;
  right: 0;
  margin-top: 10px;
  margin-right: 20px;
  z-index: 1;
  width: 50px;
  height: 50px;
  background: #4fc1ec;
  border-color: #4fc1ec;
}

#copyButton .v-icon {
  font-size: 30pt;
}

#downloadButton .v-icon {
  font-size: 30pt;
}

.restart-button {
  right: 5px;
  top: 10px;
  position: absolute;
}
</style>
